<template>
  <div class="columns">

    <div class="column">

      <!-- HINWEIS -->
      <div class="field">
        <label class="label">Vorschau</label>
        <p class="help">Das Karten-Modul befindet sich aktuell in Entwicklung.</p>
      </div>

      <!-- BREITENGRAD -->
      <div class="field">
        <label class="label">Breitengrad (lat)</label>
        <p class="help">Breitengrad des angezeigten Kartenausschnitts.</p>
        <div class="control">
          <input
            class="input"
            type="number"
            step="any"
            v-model.number="lat"
            v-on:change="onCoordInput" />
        </div>
      </div>
      <!--            -->

      <!-- LÄNGENGRAD -->
      <div class="field">
        <label class="label">Längengrad (lng)</label>
        <p class="help">Längengrad des angezeigten Kartenausschnitts.</p>
        <div class="control">
          <input
            class="input"
            type="number"
            step="any"
            v-model.number="lng"
            v-on:change="onCoordInput" />
        </div>
      </div>
      <!--            -->

      <!-- EIGENER MARKER -->
      <div class="field">
        <label class="label">Eigener Standort-Marker</label>
        <p class="help">Ist diese Option aktiv, wird an den angegebenen Koordinaten ein eigener Marker gesetzt.</p>
        <div class="control">
          <input type="checkbox" v-model="useCustomLocationMarker" v-on:change="update" />
        </div>
      </div>
      <!--            -->

    </div>

    <!-- /////////////////////////////////////////////////////////////////// -->

    <div class="column">

      <!-- KARTE ZUR AUSWAHL -->
      <div class="field">
        <label class="label">Standort wählen</label>
        <p class="help">Klicke in die Karte oder ziehe den Marker, um die Koordinaten zu setzen.</p>
        <div class="control">
          <div class="map-picker" ref="mapPicker"></div>
        </div>
      </div>
      <!--            -->

    </div>

  </div>
</template>

<script>

  import L from 'leaflet'
  import 'leaflet/dist/leaflet.css'

  export default {
    props: ['value'],
    data() {
      // Bestehende Module wurden ohne diese Felder gespeichert
      const content = this.value ? this.value : {};
      return {
        lat                     : content.lat                     != null ? content.lat : 47.7386,
        lng                     : content.lng                     != null ? content.lng : 13.4472,
        useCustomLocationMarker : content.useCustomLocationMarker != null ? content.useCustomLocationMarker : false
      }
    },
    components : {

    },
    methods: {
      update() {
        this.$emit('input', {
          lat                     : this.lat,
          lng                     : this.lng,
          useCustomLocationMarker : this.useCustomLocationMarker
        });
      },
      round(value) {
        return Math.round(value * 1000000) / 1000000;
      },
      hasValidCoords() {
        return isFinite(this.lat) && isFinite(this.lng);
      },
      // Karte an die Eingabefelder angleichen
      applyToMap(recenter) {
        if (!this.map || !this.hasValidCoords()) { return; }
        this.marker.setLatLng([this.lat, this.lng]);
        if (recenter) { this.map.setView([this.lat, this.lng]); }
      },
      onCoordInput() {
        this.applyToMap(true);
        this.update();
      },
      // Auswahl per Klick oder Marker ziehen
      onMapPick(latlng) {
        this.lat = this.round(latlng.lat);
        this.lng = this.round(latlng.lng);
        this.applyToMap(false);
        this.update();
      },
      initMap() {
        const start = this.hasValidCoords() ? [this.lat, this.lng] : [47.7386, 13.4472];

        // Leaflet Instanzen bewusst nicht in data(), sonst macht Vue sie reaktiv
        this.map = L.map(this.$refs.mapPicker).setView(start, 13);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this.map);

        // divIcon statt Standard-Marker, damit keine Bild-Assets gebundlet werden müssen
        this.marker = L.marker(start, {
          draggable: true,
          icon: L.divIcon({
            className: '',
            html: '<div style="width:18px;height:18px;border-radius:50%;background:#3273dc;border:3px solid #fff;box-shadow:0 0 0 1px rgba(0,0,0,0.3)"></div>',
            iconSize: [18, 18],
            iconAnchor: [9, 9]
          })
        }).addTo(this.map);

        this.map.on('click', (event) => this.onMapPick(event.latlng));
        this.marker.on('dragend', () => this.onMapPick(this.marker.getLatLng()));

        // Karte wird erst nach dem Laden des Assets sichtbar, daher neu vermessen
        this.$nextTick(() => this.map.invalidateSize());
      }
    },
    mounted() {
      // Defaults sofort übernehmen, damit sie auch ohne Änderung gespeichert werden
      this.update();
      this.initMap();
    },
    beforeDestroy() {
      // Beim Wechsel des Modul-Typs wird die Komponente zerstört
      if (this.map) {
        this.map.remove();
        this.map = null;
        this.marker = null;
      }
    }
  }

</script>

<style scoped>

  .map-picker {
    height: 400px;
    width: 100%;
  }

</style>
